import React from 'react';

import type { DeveloperPromoConfigs } from './types';

const DeveloperPromoConfigsContext = React.createContext<{
    developerPromoConfigs: DeveloperPromoConfigs;
}>({
    developerPromoConfigs: {}
});

export const DeveloperPromoConfigsProvider = ({
    developerPromoConfigs,
    children
}: {
    developerPromoConfigs: DeveloperPromoConfigs;
    children: React.ReactNode;
}) => (
    <DeveloperPromoConfigsContext.Provider value={{
        developerPromoConfigs
    }}>
        {children}
    </DeveloperPromoConfigsContext.Provider>
);

export const useDeveloperPromoConfigsContext = () => React.useContext(DeveloperPromoConfigsContext);
